import React from "react";
import { TextField } from "@mui/material";
import ReactSelect from "react-select";
import DatePicker2 from "../DatePicker/DatePicker2";
import { createNumberArrayOptions } from "../../Utils/createNumberArray";
import {
  learnerOptions,
  programOptions,
  programOptions2,
} from "../../Pages/GenesisIframe/constant";
import "./filter.scss";

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    width: "150px",
    minHeight: "30px",
    height: "auto",
    borderColor: "#65558f",
    borderWidth: "2.1px",
    boxShadow: state.isFocused ? "2.1px #65558f" : "none",
    "&:hover": {
      borderColor: "rebeccapurple",
    },
    backgroundColor: "#f8f8f8",
  }),

  // Style for the value container (where the selected value/placeholder appears)
  valueContainer: (provided) => ({
    ...provided,
    padding: "0 8px", // Adjust padding inside the control
    flexWrap: "nowrap", // Prevent wrapping of selected tags in multi-select
  }),

  // Style for the input field
  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: '12px', // Example: Make the selected text larger
  }),

  // Style for the placeholder text
  placeholder: (provided) => ({
    ...provided,
    fontSize: "12px",
  }),

  // Style for the dropdown menu
  menu: (provided) => ({
    ...provided,
    backgroundColor: "#f0f8ff", // Background color of the dropdown
    borderRadius: "8px", // Rounded corners for the dropdown
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", // Subtle shadow for the dropdown
    fontSize: "12px"
  }),

  // Style for individual options in the dropdown
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused
      ? "#d1c1e3" // Background color on hover
      : state.isSelected
      ? "#c5b2dc" // Background color of selected option
      : "#d1c1e3", // Default background color
    color: state.isSelected ? "#4A4459" : "#1D1B20", // Text color of selected option and default
    padding: "10px 12px",
    cursor: "pointer",
    "&:active": {
      backgroundColor: "#d8bfd8", // Background color when actively clicked
    },
  }),

  // Style for the indicator separator (the vertical line between input and dropdown arrow)
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "lightgray", // Color of the separator
  }),

  // Style for the dropdown indicator (the arrow icon) - if you want to keep it and style it
  dropdownIndicator: (provided, state) => ({
    ...provided,
    color: state.isFocused ? "darkblue" : "gray", // Color of the arrow on focus and default
    "&:hover": {
      color: "rebeccapurple", // Color of the arrow on hover
    },
  }),
};

const Filter = ({
  dateDatePickerFilter = false,
  dateRangeFilter = false,
  onFromDateChange,
  fromDate,
  onToDateChange,
  toDate,
  treatmentType,
  handleSetTreatmentType,
  fromMonthNumber,
  onFromMonthNumberChange,
  toMonthNumber,
  onToMonthNumberChange,
  monthFilterLength = 5,
  learnerFilter = false,
  learnerType,
  handleLearnerTypeChange,
  minDate = "2020-01-01",
  locationFilter = false,
  locationList,
  location,
  handleLocationChange,
  franchiseLocationFilter = false,
  franchiseesLocations,
  genesisLocation,
  selectedfranchiseesLocation,
  isCohortAnalysisChart = false,
}) => {
  return (
    <div className="filter-container">
      {franchiseLocationFilter && (
        <div className="select-box-1">
          <p>Select Franchisees</p>
          <ReactSelect
            options={franchiseesLocations}
            value={selectedfranchiseesLocation}
            onChange={(location) =>
              handleLocationChange(location, "franchisees")
            }
            components={{ DropdownIndicator: null }}
            styles={customStyles}
            placeholder="Select location"
          />
        </div>
      )}
      {locationFilter && (
        <div className="select-box-1">
          <p>Select Genesis Locations</p>
          <ReactSelect
            options={locationList}
            value={genesisLocation}
            onChange={(location) => handleLocationChange(location, "genesis")}
            components={{ DropdownIndicator: null }}
            styles={customStyles}
            placeholder="Select location"
          />
        </div>
      )}
      {dateDatePickerFilter && (
        <>
          {" "}
          <DatePicker2
            views={["year", "month"]}
            onChange={() => false}
            onAccept={onFromDateChange}
            value={fromDate}
            // label="From month"
            minDate={new Date(minDate)}
            maxDate={new Date()}
            renderInput={(params) => (
              <TextField
                {...params}
                error={false}
                placeholder="From month" // Set the placeholder text
                inputProps={{
                  ...params.inputProps,
                  placeholder: "From month", 
                }}
              />
            )}
            className="date-picker"
          />
          <DatePicker2
            views={["year", "month"]}
            onChange={() => false}
            onAccept={onToDateChange}
            value={toDate}
            // label="To month"
            minDate={new Date(minDate)}
            maxDate={new Date()}
            sx={{ height: "44px" }}
            renderInput={(params) => (
              <TextField
                {...params}
                error={false}
                placeholder="To month" // Set the placeholder text
                inputProps={{
                  ...params.inputProps,
                  placeholder: "To month", // Set the placeholder text
                }}
              />
            )}
            className="date-picker"
          />
        </>
      )}
      {dateRangeFilter && (
        <>
          <div className="select-box-1">
            <p>From Month</p>
            <ReactSelect
              options={createNumberArrayOptions(monthFilterLength)}
              value={fromMonthNumber}
              onChange={(num) => onFromMonthNumberChange(num)}
              components={{ DropdownIndicator: null }}
              styles={customStyles}
              placeholder="Select From Month"
            />
          </div>
          <div className="select-box-1">
            <p>To Month</p>
            <ReactSelect
              options={createNumberArrayOptions(monthFilterLength)}
              value={toMonthNumber}
              onChange={(num) => onToMonthNumberChange(num)}
              components={{ DropdownIndicator: null }}
              styles={customStyles}
              placeholder="Select To Month"
            />
          </div>
        </>
      )}
      {learnerFilter && (
        <div className="select-box-1">
          <p>Learner Type</p>
          <ReactSelect
            options={learnerOptions}
            value={learnerType}
            onChange={(learner) => handleLearnerTypeChange(learner)}
            components={{ DropdownIndicator: null }}
            styles={customStyles}
            placeholder="Select Learner"
          />
        </div>
      )}
      <div className="select-box-1">
        <p>Choose Program</p>
        <ReactSelect
          options={isCohortAnalysisChart ? programOptions2 : programOptions}
          value={treatmentType}
          onChange={(treatment) => handleSetTreatmentType(treatment)}
          components={{ DropdownIndicator: null }}
          styles={customStyles}
          placeholder="Select Treatment"
        />
      </div>
    </div>
  );
};

export default Filter;
